import React from "react";
import ClientFooter from "./ClientFooter";

const HomeFAQ = () => {
    return (
        <>
            {/* <style>
                {`
                    .accordion .accordion-item {
                        background-color: #ffffff00 !important;
                        border-radius: 12px;
                        overflow: hidden;
                        margin-bottom: 20px;
                        padding: 0px;
                        border: none !important;
                    }
                `}
            </style> */}
            {/* End Testimonial Area  */}
            {/* Start Accordion Area  */}
            {/* <div className="rbt-accordion-area accordion-style-1 rbt-accordion-color-white bg-color-darker rbt-section-gapBottom pt--60 pt_sm--0 overflow-hidden position-relative top-circle-shape-top overlpping-call-to-action" id="FAQ">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8 offset-lg-2 col-sm-12">
                            <div className="section-title text-center pb--60">
                                <span className="subtitle bg-secondary-opacity">
                                    Check out our FAQ section to see if we can help.
                                </span>
                                <h2 className="title mb_sm--0 text-center color-white-off">
                                    Do you have any Question
                                </h2>
                            </div>
                            <div className="rbt-accordion-style rbt-accordion-02 accordion">
                                <div className="accordion" id="accordionExamplea1">
                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingOne">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne"
                                                aria-expanded="true"
                                                aria-controls="collapseOne"
                                            >
                                                What is included in this mentorship program?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="headingOne"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                Our mentorship is designed to guide both beginners and experienced traders in the world of options trading.
                                                <br /><br />
                                                • For beginners: We start from the absolute basics and take you step-by-step to advanced-level options trading. You'll learn everything from understanding options, strike selection, to risk management and live market decision making.
                                                <br /><br />
                                                • For experienced traders: We dive deep into advanced options buying techniques, focusing on real-time decision making using Open Interest (OI) chart analysis. You'll learn powerful and unique concepts that are not commonly taught elsewhere specifically designed to help you gain an edge in intraday.
                                                <br /><br />
                                                This program is more than just theory it's built around real market experience, live examples, and specialized OI based insights that make it truly one-of-a-kind for options traders.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingTwo">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseTwo"
                                                aria-expanded="false"
                                                aria-controls="collapseTwo"
                                            >
                                                Is this course suitable for beginners?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseTwo"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingTwo"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                Yes, we start from the basics and gradually move to advanced strategies, so both beginners and experienced traders can benefit.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingThree">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseThree"
                                                aria-expanded="false"
                                                aria-controls="collapseThree"
                                            >
                                                I'm a beginner. Can I join this course without any trading experience?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseThree"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingThree"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                Yes! Our Beginners' Course is designed for those with no prior experience. We teach everything from the ground up including market basics, trading platforms, order types, and the fundamentals of trading.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingFour">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseFour"
                                                aria-expanded="false"
                                                aria-controls="collapseFour"
                                            >
                                                What makes your mentorship different from others?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseFour"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingFour"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                We don't just teach strategies we guide you live in the market, give real-time feedback, and focus on building discipline, strong psychology, and a proper risk-to-reward mindset. Our goal is to make you an independent trader, not just a follower.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingFive">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseFive"
                                                aria-expanded="false"
                                                aria-controls="collapseFive"
                                            >
                                                I'm interested in options buying. Do I need experience for that?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseFive"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingFive"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                Yes, for the Options Buying Course, we strongly recommend at least 1 year of trading experience. This course covers advanced concepts like price action and OI chart analysis, which require a good understanding of market behavior.
                                                <br /><br />
                                                If you're a beginner, we suggest completing the Basics Course first before moving on to options buying.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingSix">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseSix"
                                                aria-expanded="false"
                                                aria-controls="collapseSix"
                                            >
                                                Is this a one-time payment or subscription-based?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseSix"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingSix"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                This is a one-time payment, but access is time-limited:
                                                <br /><br />
                                                • Course videos and PDFs are valid for 6 months from the date of enrollment.
                                                <br />
                                                • Live market support includes 10 live sessions over 1 month.
                                                <br /><br />
                                                After that, live session access will expire. If you wish to continue with live support after it expires, you can renew separately by purchasing it again.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingSeven">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseSeven"
                                                aria-expanded="false"
                                                aria-controls="collapseSeven"
                                            >
                                                How do I access the course and mentorship after payment?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseSeven"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingSeven"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                After your payment is confirmed, you'll receive a WhatsApp or email verification link. Once verified, you'll get access to our private group and course materials.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingEight">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseEight"
                                                aria-expanded="false"
                                                aria-controls="collapseEight"
                                            >
                                                Can I ask doubts after completing the course?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseEight"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingEight"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                Yes, after every class, there will be a doubt-clearing session where you can ask questions and clarify anything directly with me. You'll have full support to make sure you understand each topic clearly.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingNine">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseNine"
                                                aria-expanded="false"
                                                aria-controls="collapseNine"
                                            >
                                                Is this a pre-recorded video course?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseNine"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingNine"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                Yes, the course includes pre-recorded videos with real market chart explanations.
                                                After each class, you'll also have a live doubt-clearing session to ask questions and get personalized support.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingTen">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseTen"
                                                aria-expanded="false"
                                                aria-controls="collapseTen"
                                            >
                                                Are refunds available if I don't like the course?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseTen"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingTen"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                Due to the digital nature of the course and instant access to exclusive content, we do not offer refunds.
                                                We recommend reviewing all details and our no-refund policy in the Terms & Conditions before enrolling.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item card">
                                        <h2 className="accordion-header card-header" id="headingEleven">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseEleven"
                                                aria-expanded="false"
                                                aria-controls="collapseEleven"
                                            >
                                                Will you provide any stock calls or investment recommendations?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapseEleven"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingEleven"
                                            data-bs-parent="#accordionExamplea1"
                                        >
                                            <div className="accordion-body card-body">
                                                No, we do not provide any calls or investment advice.
                                                We are not SEBI-registered advisors, and this mentorship is strictly for educational purposes only.
                                                Our live sessions and content are focused on teaching strategies, market analysis, and trading psychology — not giving buy/sell recommendations.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
    <h4 className="title" style={{ textAlign: 'center', width: '100%' }}  id="FAQ"> Check out our FAQ section to see if we can help.</h4>
<div className="rbt-accordion-area accordion-style-1 bg-color-white rbt-section-gap">
    
                <div className="container">

            
                    <div className="row g-5">
                        <div className="col-lg-6">
                            <div className="rbt-accordion-style accordion">
                             
                                <div className="rbt-accordion-style rbt-accordion-04 accordion">
                                    <div className="accordion" id="accordionExamplec3">
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="headingThree1">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree1" aria-expanded="true" aria-controls="collapseThree1">
                                                    What is included in this mentorship program?
                                                </button>
                                            </h2>
                                            <div id="collapseThree1" className="accordion-collapse collapse show" aria-labelledby="headingThree1" data-bs-parent="#accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    <p>Our mentorship is designed to guide both beginners and experienced traders in the world of options trading.</p>
                                                    <ul>
                                                        <li>For beginners: We start from the absolute basics and take you step-by-step to advanced-level options trading. You'll learn everything from understanding options, strike selection, to risk management and live market decision making.</li>
                                                        <li>For experienced traders: We dive deep into advanced options buying techniques, focusing on real-time decision making using Open Interest (OI) chart analysis. You'll learn powerful and unique concepts that are not commonly taught elsewhere specifically designed to help you gain an edge in intraday.</li>
                                                    </ul>
                                                    <p>This program is more than just theory it's built around real market experience, live examples, and specialized OI based insights that make it truly one-of-a-kind for options traders.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="headingThree2">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree2" aria-expanded="false" aria-controls="collapseThree2">
                                                    Is this course suitable for beginners?
                                                </button>
                                            </h2>
                                            <div id="collapseThree2" className="accordion-collapse collapse" aria-labelledby="headingThree2" data-bs-parent="#accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    Yes, we start from the basics and gradually move to advanced strategies, so both beginners and experienced traders can benefit.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="headingThree3">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree3" aria-expanded="false" aria-controls="collapseThree3">
                                                    I'm a beginner. Can I join this course without any trading experience?
                                                </button>
                                            </h2>
                                            <div id="collapseThree3" className="accordion-collapse collapse" aria-labelledby="headingThree3" data-bs-parent="#accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    Yes! Our Beginners' Course is designed for those with no prior experience. We teach everything from the ground up including market basics, trading platforms, order types, and the fundamentals of trading.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="headingThree4">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree4" aria-expanded="false" aria-controls="collapseThree4">
                                                    What makes your mentorship different from others?
                                                </button>
                                            </h2>
                                            <div id="collapseThree4" className="accordion-collapse collapse" aria-labelledby="headingThree4" data-bs-parent="#accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    We don't just teach strategies we guide you live in the market, give real-time feedback, and focus on building discipline, strong psychology, and a proper risk-to-reward mindset. Our goal is to make you an independent trader, not just a follower.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="headingThree5">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree5" aria-expanded="false" aria-controls="collapseThree5">
                                                    I'm interested in options buying. Do I need experience for that?
                                                </button>
                                            </h2>
                                            <div id="collapseThree5" className="accordion-collapse collapse" aria-labelledby="headingThree5" data-bs-parent="#accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    Yes, for the Options Buying Course, we strongly recommend at least 1 year of trading
                                                    experience. This course covers advanced concepts like price action and OI chart analysis,
                                                    which require a good understanding of market behavior.
                                                    If you're a beginner, we suggest completing the Basics Course first before moving on
                                                    to options buying.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="rbt-accordion-style accordion">
                              
                                <div className="rbt-accordion-style rbt-accordion-04 accordion">
                                    <div className="accordion" id="faqs-accordionExamplec3">
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="faqs-headingThree1">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqs-collapseThree1" aria-expanded="true" aria-controls="faqs-collapseThree1">
                                                    Is this a one-time payment or subscription-based?
                                                </button>
                                            </h2>
                                            <div id="faqs-collapseThree1" className="accordion-collapse collapse show" aria-labelledby="faqs-headingThree1" data-bs-parent="#faqs-accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    <p>This is a one-time payment, but access is time-limited:</p>
                                                    <ul>
                                                        <li>Course videos and PDFs are valid for 6 months from the date of enrollment.</li>
                                                        <li>Live market support includes 10 live sessions over 1 month.</li>
                                                    </ul>
                                                    <p>After that, live session access will expire. If you wish to continue with live support after it expires, you can renew separately by purchasing it again.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="faqs-headingThree2">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs-collapseThree2" aria-expanded="false" aria-controls="faqs-collapseThree2">
                                                    How do I access the course and mentorship after payment?
                                                </button>
                                            </h2>
                                            <div id="faqs-collapseThree2" className="accordion-collapse collapse" aria-labelledby="faqs-headingThree2" data-bs-parent="#faqs-accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    After your payment is confirmed, you'll receive a WhatsApp or email verification link. Once verified, you'll get access to our private group and course materials.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="faqs-headingThree3">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs-collapseThree3" aria-expanded="false" aria-controls="faqs-collapseThree3">
                                                    Can I ask doubts after completing the course?
                                                </button>
                                            </h2>
                                            <div id="faqs-collapseThree3" className="accordion-collapse collapse" aria-labelledby="faqs-headingThree3" data-bs-parent="#faqs-accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    Yes, after every class, there will be a doubt-clearing session where you can ask questions and clarify anything directly with me. You'll have full support to make sure you understand each topic clearly.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="faqs-headingThree4">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs-collapseThree4" aria-expanded="false" aria-controls="faqs-collapseThree4">
                                                    Is this a pre-recorded video course?
                                                </button>
                                            </h2>
                                            <div id="faqs-collapseThree4" className="accordion-collapse collapse" aria-labelledby="faqs-headingThree4" data-bs-parent="#faqs-accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    Yes, the course includes pre-recorded videos with real market chart explanations.
                                                    After each class, you'll also have a live doubt-clearing session to ask questions and get
                                                    personalized support.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="faqs-headingThree5">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs-collapseThree5" aria-expanded="false" aria-controls="faqs-collapseThree5">
                                                    Are refunds available if I don't like the course?
                                                </button>
                                            </h2>
                                            <div id="faqs-collapseThree5" className="accordion-collapse collapse" aria-labelledby="faqs-headingThree5" data-bs-parent="#faqs-accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    Due to the digital nature of the course and instant access to exclusive content, we do not
                                                    offer refunds.
                                                    We recommend reviewing all details and our no-refund policy in the Terms &amp; Conditions
                                                    before enrolling.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item card">
                                            <h2 className="accordion-header card-header" id="faqs-headingThree6">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqs-collapseThree6" aria-expanded="false" aria-controls="faqs-collapseThree6">
                                                    Will you provide any stock calls or investment recommendations?
                                                </button>
                                            </h2>
                                            <div id="faqs-collapseThree6" className="accordion-collapse collapse" aria-labelledby="faqs-headingThree6" data-bs-parent="#faqs-accordionExamplec3">
                                                <div className="accordion-body card-body">
                                                    No, we do not provide any calls or investment advice. We are not SEBI-registered advisors, and this mentorship is strictly for educational purposes only. Our live sessions and content are focused on teaching strategies, market analysis, and trading psychology — not giving buy/sell recommendations.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Accordion Area  */}
        </>

    );
};

export default HomeFAQ;
